import { browserTimezone } from "@/lib/timeago";

// One timezone drives the whole platform: whatever the member chose in Account Settings.
// AuthContext publishes it here so any form or display can prefill without asking again.
let accountZone = "";

export const setAccountTimezone = (tz) => {
  accountZone = (tz || "").includes("/") ? tz : "";
};

/** The member's Account Settings zone, falling back to the browser's when they have none. */
export const preferredTimezone = () => accountZone || browserTimezone();

/** Reference rows store a slug `value` with the real IANA name as the `label`. */
export const toIana = (list, value) => {
  if (!value) return "";
  if (value.includes("/")) return value;
  const match = (list || []).find((t) => t.value === value);
  return match ? match.label : "";
};

export const toRefValue = (list, iana) => {
  if (!iana) return "";
  const match = (list || []).find((t) => t.label === iana);
  return match ? match.value : "";
};
